/* assets/buy-online.js
   - Builds the hero row: all featured chips + N random pool chips (Fisher–Yates).
   - Moves the rest of the pool into the "more" text list (all links stay in the DOM).
   - Re-derives monogram + deterministic accent from each name so promoted chips match.
   - UK / International toggle with localStorage memory.
   - Sticky "Where to Buy" jump (IntersectionObserver).
   - stockist_click event pushed to the GTM dataLayer per stockist.
*/
(function () {
  var ACCENTS = ["#C9762E","#B08541","#8C7A55","#6E7B6B","#5E7079","#8A6A50","#9A7B4A","#5F6B7A","#77705F","#7A6660"];

  function accentFor(name) {
    var h = 0;
    for (var i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
    return ACCENTS[h % ACCENTS.length];
  }
  function monogram(name) {
    var clean = name.replace(/[^a-zA-Z0-9 ]/g, "").trim();
    var w = clean.split(/\s+/);
    if (w.length >= 2) return (w[0][0] + w[1][0]).toUpperCase();
    return clean.slice(0, 2).toUpperCase();
  }
  function shuffle(a) {
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }
  var ARROW = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M7 17 17 7M7 7h10v10"/></svg>';
  var SHIELD = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1Z"/><path d="m9 12 2 2 4-4"/></svg>';
  var STAR = '<svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1" stroke-linejoin="round" aria-hidden="true"><path d="m12 2 3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';

  function domainOf(url) {
    try { return new URL(url).hostname.replace(/^www\./, ""); } catch (e) { return ""; }
  }
  function markHTML(name, url) {
    var d = domainOf(url);
    if (d) {
      return '<img class="sp-fav" src="https://icons.duckduckgo.com/ip3/' + d + '.ico" ' +
        'data-domain="' + d + '" data-mono="' + monogram(name) + '" alt="' + name.replace(/"/g, "") + ' logo" loading="lazy">';
    }
    return '<span class="sp-mono" aria-hidden="true">' + monogram(name) + '</span>';
  }

  // Robust favicon handling: DuckDuckGo -> Google -> clean monogram.
  // Auto-detects low-res / default icons (naturalWidth < 24) and falls back.
  function enhanceFavicons(root) {
    root.querySelectorAll(".sp-fav[data-domain]").forEach(function (img) {
      if (img._sp) return;
      img._sp = true;
      var d = img.getAttribute("data-domain");
      var mono = img.getAttribute("data-mono") || "";
      var srcs = [
        "https://icons.duckduckgo.com/ip3/" + d + ".ico",
        "https://www.google.com/s2/favicons?domain=" + d + "&sz=128",
      ];
      var i = 0;
      function toMono() {
        var s = document.createElement("span");
        s.className = "sp-mono";
        s.setAttribute("aria-hidden", "true");
        s.textContent = mono;
        if (img.parentNode) img.parentNode.replaceChild(s, img);
      }
      function advance() {
        if (i < srcs.length - 1) { i++; img.src = srcs[i]; } else { toMono(); }
      }
      img.addEventListener("error", advance);
      img.addEventListener("load", function () {
        if (img.naturalWidth && img.naturalWidth < 24) advance();
      });
      if (img.complete) {
        if (!img.naturalWidth) advance();
        else if (img.naturalWidth < 24) advance();
      }
    });
  }

  function buildChip(name, url) {
    var a = document.createElement("a");
    a.className = "sp-card";
    a.href = url;
    a.target = "_blank";
    a.rel = "sponsored noopener noreferrer";
    a.setAttribute("data-sp-chip", "");
    a.setAttribute("data-sp-name", name);
    a.style.setProperty("--acc", accentFor(name));
    a.innerHTML =
      '<span class="sp-flags"><svg class="sp-flags__star" width="13" height="13" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1" stroke-linejoin="round" aria-hidden="true"><path d="m12 2 3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>' +
      '<svg class="sp-flags__shield" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1Z"/><path d="m9 12 2 2 4-4"/></svg></span>' +
      '<span class="sp-brand"><span class="sp-mark">' + markHTML(name, url) + '</span>' +
      '<span class="sp-name">' + name + '</span></span>' +
      '<span class="sp-arrow" aria-hidden="true">' + ARROW + '</span>';
    return a;
  }

  function boot() {
    var panel = document.querySelector('[data-testid="buy-online-panel"]');
    if (!panel) return;

    // Re-derive accent + monogram for the server-rendered featured chips.
    panel.querySelectorAll(".sp-grid [data-sp-chip]").forEach(function (c) {
      var n = c.getAttribute("data-sp-name");
      if (!n) return;
      c.style.setProperty("--acc", accentFor(n));
      var m = c.querySelector(".sp-mono");
      if (m) m.textContent = monogram(n);
    });

    // Promote N random pool entries into the hero row.
    var grid = panel.querySelector("[data-sp-grid]");
    var pool = panel.querySelector("[data-sp-pool]");
    var n = parseInt(panel.getAttribute("data-sp-random"), 10) || 0;
    if (grid && pool && n > 0) {
      var lis = Array.prototype.slice.call(pool.querySelectorAll("li"));
      shuffle(lis).slice(0, n).forEach(function (li) {
        var link = li.querySelector("a");
        if (!link) return;
        grid.appendChild(buildChip(link.getAttribute("data-sp-name"), link.href));
        li.parentNode.removeChild(li);
      });
    }
    // Update remaining "more" count.
    var countEl = panel.querySelector("[data-sp-count]");
    if (countEl && pool) countEl.textContent = pool.querySelectorAll("li").length;

    // Robust favicon handling for every chip (server + promoted).
    enhanceFavicons(panel);

    // Region toggle
    var views = panel.querySelectorAll("[data-sp-view]");
    var btns = panel.querySelectorAll(".sp-toggle__btn");
    var hintEl = panel.querySelector("[data-sp-hint]");
    function setRegion(region) {
      var uk = region === "UK";
      views.forEach(function (v) { v.hidden = v.getAttribute("data-sp-view") !== region; });
      btns.forEach(function (b) {
        var on = b.getAttribute("data-sp-region") === region;
        b.classList.toggle("is-active", on);
        b.setAttribute("aria-selected", on ? "true" : "false");
      });
      if (hintEl) hintEl.textContent = uk ? hintEl.getAttribute("data-hint-uk") : hintEl.getAttribute("data-hint-intl");
      try { localStorage.setItem("sp-region", region); } catch (e) {}
    }
    btns.forEach(function (b) {
      b.addEventListener("click", function () { setRegion(b.getAttribute("data-sp-region")); });
    });
    // Soft geo default: overseas visitors open on International (browser timezone/locale,
    // no network call). A saved manual choice always wins.
    var start = "UK";
    try {
      var saved = localStorage.getItem("sp-region");
      if (saved) {
        start = saved;
      } else {
        var tz = (Intl.DateTimeFormat().resolvedOptions().timeZone) || "";
        var lang = (navigator.language || "").toLowerCase();
        start = (tz === "Europe/London" || lang === "en-gb") ? "UK" : "International";
      }
    } catch (e) {}
    setRegion(start);

    // Outbound stockist click -> GTM dataLayer (works with GTM-only setups where
    // window.gtag isn't exposed). GTM then forwards it to GA4 via a Custom Event trigger.
    panel.addEventListener("click", function (e) {
      var link = e.target.closest("a[data-sp-name]");
      if (!link) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "stockist_click",
        stockist_name: link.getAttribute("data-sp-name"),
        link_url: link.href,
        region: (function () { try { return localStorage.getItem("sp-region") || "UK"; } catch (e) { return "UK"; } })()
      });
    });

    // Sticky "Where to Buy" jump — appears only while the panel is off-screen.
    var sticky = panel.querySelector("[data-sp-scroll]");
    if (sticky) {
      sticky.addEventListener("click", function () {
        var details = panel.querySelector(".sp-details");
        if (details) details.open = true;
        panel.scrollIntoView({ behavior: "smooth", block: "center" });
      });
      if ("IntersectionObserver" in window) {
        var io = new IntersectionObserver(function (entries) {
          sticky.classList.toggle("is-visible", !entries[0].isIntersecting);
        }, { threshold: 0, rootMargin: "-40px 0px" });
        io.observe(panel.querySelector(".sp-details") || panel);
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
